import SortableListPersistence from '../react/SortableListPersistence'

export default class AllFilter {
  constructor(params) {
    this.params = params;
    this.lists = {};
    this.data = {};

    this.selector = params.selector
    this.setupLocalPersistance();
    this.bindAllFilterHandler();
    this.setupFilter();
  }

  setupLocalPersistance() {
    this.persistence = new SortableListPersistence({objectref: this.selector})
    this.filter = this.persistence.getSortKey() || "all";
  }

  addList(listId, data, listObj) {
    this.data[listId] = data;
    this.lists[listId] = listObj;
    $('#current-all-filter').text($(`${this.selector} li[data-title="${this.filter}"]`).data("name"));
    this.setFilter(this.filter)
  }

  bindAllFilterHandler() {
    N2.handle("click", `${this.selector} li`, (e) => {
      e.preventDefault();
      let $target = $(e.currentTarget);
      $target.parent().find(".material-icons:not(.d-none)").addClass("d-none")
      $target.children(".text-right").children().removeClass("d-none")
      $('#current-all-filter').text($target.data('name'));
      this.setFilter($target.data('title'));
      this.persistence.setSortKey(($target.data('title')));
    });
  }

  filterJobs() {
    // override in class
  }

  setFilter(newAllFilter) {
    this.filter = newAllFilter;

    $.each(this.lists, (key, list) => {
      list.updateData(key, this.filterJobs(this.data[key]));
    });
  }

  setupFilter() {
    $(`${this.selector} li[data-title="${this.filter}"]`).children(".text-right").children().removeClass("d-none")
  }
}
